export default "__VITE_ASSET__16671476__"